import { Alert, Snackbar } from '@mui/material';
import React from 'react';

export default function Notification(props: any) {
    const { notify, setNotify } = props;

    const handleClose = () => {
        setNotify({
            ...notify,
            isOpen: false
        })
    }

    return (
        <Snackbar
            open={notify.isOpen}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            onClose={handleClose}>
            <Alert
                severity={notify?.type}
                onClose={() => handleClose()}>
                {notify.message}
            </Alert>
        </Snackbar>
    )
}